// extracted by mini-css-extract-plugin
export var divider = "_rq-0";
export var systemMessage = "_rq-1";
export var systemMessageWrapper = "_rq-2";